import SEOSchema from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import HotLeaksSection from './components/HotLeaksSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <SEOSchema
        type="WebSite"
        data={{
          name: '911爆料网',
          url: 'https://911baoliao.com',
          description: '911爆料网，第一时间放出猛料。网红反差视频、博主私下爆料、明星聊天记录泄露，全网最快吃瓜平台。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://911baoliao.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <SEOSchema
        type="Organization"
        data={{
          name: '911爆料网',
          url: 'https://911baoliao.com',
          description: '全网最快吃瓜爆料平台，911爆料网App与下载通道，承接全网吃瓜黑料内容。',
        }}
      />

      <HeroSection />
      <HotLeaksSection />
      <TestimonialSection />
      <CTASection />

      <section className="py-16 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-10">
            常见<span className="text-primary-500">问题</span>
          </h2>
          <div className="max-w-3xl mx-auto space-y-4">
            {[
              {
                q: '911爆料网是什么？',
                a: '911爆料网是一个专业的娱乐八卦资讯平台，聚焦网红圈子、娱乐圈的第一手猛料。提供网红反差视频、博主私下爆料、明星聊天记录泄露等吃瓜黑料内容，是全网最快、最全的吃瓜平台。',
              },
              {
                q: '如何下载911爆料网App？',
                a: '您可以通过本网站提供的下载入口获取911爆料网App。我们提供安卓和iOS双平台支持，下载安装后即可随时随地获取最新爆料推送。',
              },
              {
                q: '911爆料网的内容可信吗？',
                a: '我们坚持"有图有真相"的原则，所有爆料内容均经过多方核实后发布。对于未经证实的传闻，我们会明确标注"待核实"。同时提醒各位吃瓜群众理性看待，不传谣不信谣。',
              },
              {
                q: '如何向911爆料网投稿爆料？',
                a: '我们欢迎各位知情人士提供爆料线索。您可以通过网站底部的联系方式联系我们，所有爆料人均可享受匿名保护，确保您的身份信息不会泄露。',
              },
              {
                q: '911爆料网App有哪些功能？',
                a: '911爆料网App提供实时推送通知、分类浏览、搜索功能、评论区互动等核心功能。会员用户还可享受独家爆料提前查看、去广告等特权服务。',
              },
            ].map((faq, i) => (
              <details key={i} className="group bg-background-100 rounded-xl p-5 cursor-pointer">
                <summary className="flex items-center justify-between text-base font-semibold text-foreground-900">
                  {faq.q}
                  <i className="ri-add-line text-lg text-foreground-400 group-open:hidden"></i>
                  <i className="ri-subtract-line text-lg text-primary-500 hidden group-open:block"></i>
                </summary>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      <SEOSchema
        type="FAQPage"
        data={{
          mainEntity: [
            {
              '@type': 'Question',
              name: '911爆料网是什么？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '911爆料网是一个专业的娱乐八卦资讯平台，聚焦网红圈子、娱乐圈的第一手猛料。提供网红反差视频、博主私下爆料、明星聊天记录泄露等吃瓜黑料内容，是全网最快、最全的吃瓜平台。',
              },
            },
            {
              '@type': 'Question',
              name: '如何下载911爆料网App？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '您可以通过本网站提供的下载入口获取911爆料网App。我们提供安卓和iOS双平台支持，下载安装后即可随时随地获取最新爆料推送。',
              },
            },
            {
              '@type': 'Question',
              name: '911爆料网的内容可信吗？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '我们坚持有图有真相的原则，所有爆料内容均经过多方核实后发布。对于未经证实的传闻，我们会明确标注待核实。',
              },
            },
            {
              '@type': 'Question',
              name: '如何向911爆料网投稿爆料？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '我们欢迎各位知情人士提供爆料线索。您可以通过网站底部的联系方式联系我们，所有爆料人均可享受匿名保护。',
              },
            },
            {
              '@type': 'Question',
              name: '911爆料网App有哪些功能？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '911爆料网App提供实时推送通知、分类浏览、搜索功能、评论区互动等核心功能。会员用户还可享受独家爆料提前查看、去广告等特权服务。',
              },
            },
          ],
        }}
      />
    </>
  );
}